import moment from 'moment';
import Route from './Router'
import './models/notification';

Route.setBaseUrl(window.location.origin + '/');

Route.register('page', () => 'overview');
Route.register('subpage', () => '');
Route.register('id', undefined, undefined, x => parseInt(x)?.toString() == x ? parseInt(x) : x);
Route.register('tab');
Route.register('view');
['edit', 'copy', 'delete'].forEach(x => Route.register(x, undefined, x => x ? 'true' : '', x => x ? x.toLowerCase() === 'true' ? true : false : undefined));

Route.addRoute('')
    .addUrlPath('page')
    .addUrlPath('id')
    .addUrlPath('tab');

Route.hashChanged();

//
moment.locale('ru');